let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j0jxb")).then(() => parcelRequire('dNg0F'));